import {connect} from "react-redux";
import CompetitionMapping from "./CompetitionMapping";
import {bindActionCreators} from "redux";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';
import { saveCompetitionMapping, fetchSiteNameUsingLatLong } from "services/redux/installation/tagDelivery/action";


const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    saveCompetitonMappingResponse: state.tagDeliveryReducer.saveCompetitonMappingResponse,
    fetchSiteNameResponse: state.tagDeliveryReducer.fetchSiteNameResponse
  });


    const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
      {
        documentUploadUrlPublic,
        saveCompetitionMapping,
        fetchSiteNameUsingLatLong
      },
      dispatch
    );

export default connect
(mapStateToProps, mapDispatchToProps)
(CompetitionMapping);
